export const MedicalDept = {
  DENT: "DENT",
  DERM: "DERM",
  PS: "PS",
  OS: "OS",
  OPH: "OPH",
  KM: "KM",
  NS: "NS",
  CS: "CS",
  COMMON: "COMMON",
  VET_COMMON: "VET_COMMON",
};

// Surgery Types by Medical Department
export const SurgeryType = {
  // Ophthalmology (OPH)
  LASIK: "LASIK",
  LASEK: "LASEK",
  SMILE: "SMILE",
  PRESBYOND: "PRESBYOND",
  LENS: "LENS",
  REFRACTION: "REFRACTION",
  CUSTOM: "CUSTOM",
  // Dental (DENT)
  IMPLANT: "IMPLANT",
  BRACE: "BRACE",
  ABUTMENT: "ABUTMENT",
  ZIRCONIA: "ZIRCONIA",
  CROWN: "CROWN",
  IMPLANT_CROWN: "IMPLANT_CROWN",
  BRIDGE: "BRIDGE",
  INLAY: "INLAY",
  LAMINATE: "LAMINATE",
  // Plastic Surgery (PS)
  PSIMPLANT: "PSIMPLANT",
};

export const SurgeryTypeText = {
  // Ophthalmology (OPH)
  LASIK: "라식",
  LASEK: "라섹",
  SMILE: "스마일라식",
  PRESBYOND: "프레스비욘드",
  LENS: "렌즈삽입술",
  REFRACTION: "시력교정",
  CUSTOM: "기타",
  // Dental (DENT)
  IMPLANT: "임플란트",
  BRACE: "투명교정",
  ABUTMENT: "보철",
  ZIRCONIA: "지르코니아",
  CROWN: "크라운",
  IMPLANT_CROWN: "임플란트 크라운",
  BRIDGE: "브릿지",
  INLAY: "인레이",
  LAMINATE: "라미네이트",
  // Plastic Surgery (PS)
  PSIMPLANT: "성형 임플란트",
};

// Get surgery types for specific medical department
export function getSurgeryTypesByDept(dept) {
  const ophTypes = [
    "LASIK",
    "LASEK",
    "SMILE",
    "PRESBYOND",
    "LENS",
    "REFRACTION",
    "CUSTOM",
  ];
  const dentTypes = [
    "IMPLANT",
    "BRACE",
    "ABUTMENT",
    "ZIRCONIA",
    "CROWN",
    "IMPLANT_CROWN",
    "BRIDGE",
    "INLAY",
    "LAMINATE",
  ];
  const psTypes = ["PSIMPLANT"];

  switch (dept) {
    case "OPH":
      return ophTypes.map((code) => ({ code, name: SurgeryTypeText[code] }));
    case "DENT":
      return dentTypes.map((code) => ({ code, name: SurgeryTypeText[code] }));
    case "PS":
      return psTypes.map((code) => ({ code, name: SurgeryTypeText[code] }));
    default:
      return [];
  }
}

export function convertSurgeryType(value) {
  return SurgeryTypeText[value] || "";
}

export const MedicalDeptText = {
  DENT: "치과",
  DERM: "피부과",
  PS: "성형외과",
  OS: "정형외과",
  OPH: "안과",
  KM: "한의원",
  NS: "신경외과",
  CS: "흉부외과",
  COMMON: "공통",
  VET_COMMON: "수의과",
};

export function convertMedicalDept(value) {
  return MedicalDeptText[value] || "";
}

export const devices = {
  IOS: "iOS",
  AOS: "안드로이드",
  ETC: "기타",
};

export const appTypes = {
  CUSTOMER: "환자",
  HOSPITAL: "병원",
};

export const companyLogos = {
  default:
    "https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_thumbnail%252FDefault.png",
};

export const colorCodes = [
  "#CDE5FF",
  "#CCD4FF",
  "#FFD913",
  "#7798ED",
  "#BBC1C6",
  "#FECFCD",
  "#C4F4C2",
  "#FFEEA9",
  "#FC6F28",
  "#9FC210",
  "#CBF5C0",
];

export const productCodeStatus = {
  notFound: "notfound",
  exist: "exist",
  ok: "ok",
  notChecked: "",
};

export const colorCodeForCertifiedCompanies = {
  dentium: "#ACC90E",
  zeiss: "#141E8C",
};

export const enums = () => {
  return {
    WarrantyStatusEnum: {
      REQUEST_ISSUED: "request-issued", // 발행 요청됨
      ISSUED: "issued", // 지갑 저장됨
      DISPOSED: "disposed", // 삭제됨
      RETURNED: "returned", // 회수됨
      BIZ_SEND_ERROR: "biz_send_error", // 발송 실패
      SEND_LMS: "send-lms", // 문자 전송됨
      SEND_BIZ: "send-biz", // 카톡 전송됨
      WECHAT_ISSUED: "wechat-issued", // 카톡 전송됨
    },
    WarrantyStatusText: {
      ISSUED: "지갑 저장됨", // ISSUED
      DISPOSED: "삭제됨", // DISPOSED
      RETURNED: "회수됨", // RETURNED
      BIZ_SEND_ERROR: "발송 실패", // BIZ_SEND_ERROR
      SEND_LMS: "문자 전송됨", // SEND_LMS //
      SEND_BIZ: "카톡 전송됨", // SEND_BIZ //
    },
    NftTitleEnum: {
      DENTIUM: "덴티움 정품 인증서",
      PLASMAPP: "플라즈맵 정품 표면처리 인증서",
      ZEISS: "자이스 코리아", // 해야 됨
      PS_HOSPITAL: "수술 책임관리 인증서",
      PS_CERTIFIED: "정품 보형물 인증서",
      PS_NOTCERTIFIED: "보형물 시술 확인서",
      ETC: "임플란트 제품 확인서",
    },
    KlipCompanyNameEnum: {
      DENTIUM: "덴티움(Dentium)",
      PLASMAPP: "플라즈맵(Plasmapp)",
      ZEISS: "자이스 코리아",
      SUNMEDICAL: "썬메디칼(Sun Medical)",
    },
    InformTextEnum: {
      DEFAULT: `위 수술 관련 데이터의 모든 소유권과 책임은 병원에 있으며, 문의사항은 해당병원으로 부탁 드립니다.`,
      ZEISS: `위 수술 관련 데이터의 모든 소유권과 책임은 병원에 있으며, 문의사항은 해당병원으로 부탁 드립니다.`,
    },
    TraitTypeEnum: {
      COMMON: {
        DEPT: "진료 과목",
        PRODUCTTYPE: "수술/시술 구분",
        HOSPITALNAME: "병원명",
        SURGERYDATE: "수술일",
        DOCTORNAME: "수술 의사",
        COMPANYNAME: "제조사",
        INFORMTEXT: "안내사항",
        ISSUEDBY: "발행주체",
        PRODUCTNAME: "제품명",
        SPEC: "제품 사양",
      },
      DENT: {
        TOOTHNO: "치아 번호",
      },
      OPH: {},
      PS: {
        IMPLANT_COMPANY: "보형물 제조사",
        IMPLANT_NAME: "보형물 제품명",
        IMPLANT_SPEC: "보형물 사양",
        IMPLANT_NO: "보형물 정품인증번호",
        LEFT_COMPANY: "보형물(L) 제조사",
        RIGHT_COMPANY: "보형물(R) 제조사",
        LEFT_NAME: "보형물(L) 제품명",
        RIGHT_NAME: "보형물(R) 제품명",
        LEFTSPEC: "보형물(L) 제품 사양",
        RIGHTSPEC: "보형물(R) 제품 사양",
        LEFTNO: "보형물(L) 정품인증번호",
        RIGHTNO: "보형물(R) 정품인증번호",
        NO: "보형물 정품인증번호",
      },
    },
    YnEnum: {
      Y: "Y",
      N: "N",
    },
  };
};

export default enums;
